import determineVesselType from "./determine_vessel_type";

export default function selectVesselPlugin(
  trim,
  fouling,
  vessels,
  trimValues,
  foulingValues,
  imo,
) {
  const vesselTypeValues = determineVesselType(trim, fouling, trimValues, foulingValues);

  const closestTrim = vesselTypeValues.trim;
  const closestFouling = vesselTypeValues.fouling;

  const candidateVessels = vessels.filter((vessel) => {
    return vessel.imoIdentifier === imo;
  });

  const selectedVessel = candidateVessels.find((vessel) => {
    return vessel.modelTrim === closestTrim && vessel.modelFouling === closestFouling;
  });

  return selectedVessel;
}
